export const AUTO_SEARCH_STATE = "vertesia.nfwf.autoSearchState"
export const LAST_DISPLAYED_VIEW = "vertesia.nfwf.lastDisplayedView"
export const LAST_PANEL_STATE = "vertesia.nfwf.lastPanelState"
export const RENDITION_ID = "vertesia.nfwf.renditionId"